import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthState {
  user: { username?: string; key?: string } | null;
  userId: string | null;
  deviceToken: string | null;
  sessionId: string | null;
  businessId: string | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  user: null,
  userId: null,
  deviceToken: null,
  sessionId: null,
  businessId: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{
        user?: { username?: string; key?: string };
        userId?: string | null;
        deviceToken?: string | null;
        sessionId?: string | null;
        businessId?: string | null;
      }>
    ) => {
      const { user, userId, deviceToken, sessionId, businessId } = action.payload;
      if (user) state.user = user;
      if (userId !== undefined) state.userId = userId;
      if (deviceToken !== undefined) state.deviceToken = deviceToken;
      if (sessionId !== undefined) state.sessionId = sessionId;
      if (businessId !== undefined) state.businessId = businessId;
      state.isAuthenticated = !!(state.user?.key || state.deviceToken);
    },
    setSession: (state, action: PayloadAction<{ deviceToken?: string; sessionId?: string }>) => {
      const { deviceToken, sessionId } = action.payload;
      if (deviceToken !== undefined) state.deviceToken = deviceToken;
      if (sessionId !== undefined) state.sessionId = sessionId;
    },
    setBusinessId: (state, action: PayloadAction<string | null>) => {
      state.businessId = action.payload;
    },
    logout: () => initialState,
  },
});

export const { setCredentials, setSession, setBusinessId, logout } = authSlice.actions;
export default authSlice.reducer;
